// removed by extract-text-webpack-plugin
module.exports = {"Content":"examples__Content__2dF6Q","fadeInLoad":"examples__fadeInLoad__29d5w"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Examples/examples.css
// module id = 95
// module chunks = 0